module.exports = require './ColleagueGuide'
